import MD5 from 'md5';
import { UserSecretKey } from './constant';
import girl_user from '../assets/user/default_user_1.svg';
import boy_user from '../assets/user/default_user_2.svg';
import { DES, enc, mode, pad } from "crypto-js";
import log from 'loglevel';

export const defaultPicPrefix = 'https://rescexp.gameyay.com';

export const generateRandomNumber = () => {
    return 1;
  }

export const getDefaultAvatar = () => {
    return [girl_user, boy_user][generateRandomNumber()]
};

export const getCurrentTime = () => {
    const currentTime = new Date();
    const currentYear = currentTime.getFullYear();
    const currentMonth = currentTime.getMonth() + 1;
    const currentDate = currentTime.getDate();
    return currentYear + (currentMonth < 10 ? ('0' + currentMonth) : currentMonth.toString()) + (currentDate < 10 ? ('0' + currentDate) : currentDate.toString());
    
};

export const getSearchParamsCache = () => {
    const paramsCache = sessionStorage.getItem('searchCache');
    const searchCache = paramsCache && JSON.parse(paramsCache);
    return searchCache;
};

export const filterPriceSign = (str) => {
    const result = str.replaceAll('/', ' per ');
    return result;
}

export const addPicUrlPrefix = (picStringList) => {
    return picStringList.split(',').map(pic => `${defaultPicPrefix}${pic}`).join(',');
};



// * 用户信息DES加密
export function encryptData(data) {
    const secret = DES.encrypt(
        JSON.stringify(data), 
        enc.Utf8.parse(UserSecretKey), 
        {
            mode: mode.ECB,
            padding: pad.Pkcs7
        }
    ).toString();
    return secret;
}

// * 用户信息DES解密
export function decryptData(secret) {
    const data = DES.decrypt(secret, enc.Utf8.parse(UserSecretKey), {
        mode: mode.ECB,
        padding: pad.Pkcs7
    }).toString(enc.Utf8);
    return JSON.parse(data);
}

// * 日志级别设置
export const loggerSetting = (type) => {
    log.setLevel(type);
    console.log = log.debug;
    console.warn = log.warn;
    console.error = log.error;
    console.info = log.info;
}

export const replaceWithIntlCollator = (str, find, replaceWith) => {
    if (!str || !find) return str;
    
    const collator = new Intl.Collator(undefined, {
        sensitivity: 'base', // 忽略大小写和重音
        usage: 'search'
    });
    
    const findLength = find.length;
    let result = '';
    let i = 0;
    
    while (i < str.length) {
        const current = str.substr(i, findLength);
        
        if (collator.compare(current, find) === 0) {
            result += replaceWith;
            i += findLength;
        } else {
            result += str[i];
            i++;
        }
    }
    
    return result;
}

export const mergeToLabelValueArrays = (...arrays) => {
  const seen = new Set();
  const result = [];
  
  arrays.flat().forEach(item => {
    // 处理不同类型的输入
    let label, value;
    
    if (typeof item === 'string') {
      label = value = item;
    } else if (typeof item === 'object' && item !== null) {
      label = item.label || item.value || '';
      value = item.value || item.label || '';
    } else {
      // 其他类型转换为字符串
      const str = String(item);
      label = value = str;
    }
    
    // 确保value不为空
    if (value && !seen.has(value)) {
      seen.add(value);
      result.push({ label, value });
    }
  });
  
  return result;
}
